import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EndUserState } from 'types';

export const initialState: EndUserState = {
  loading: false,
  endUserList: [],
  reset: false,
  totalCount: 0,
  filter: {}
};

const slice = createSlice({
  name: 'EndUser',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setEndUserList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.endUserList = payload || [];
      state.reset = false;
    },
    setTotalCount: (state, { payload }: PayloadAction<number>) => {
      state.totalCount = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = { ...state.filter, ...payload };
    },
    clearFilter: (state) => {
      state.filter = {};
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setEndUserList, setTotalCount, setLoading, setFilter, clearFilter, reset } = slice.actions;

export default slice.reducer;
